
    import '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/tooltip.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-weet-tooltip-demo-basic","docs-weet-tooltip-demo-long-text","docs-weet-tooltip-demo-directions"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/tooltip.md?type=demo')
};